export default "__VITE_ASSET__35XUTII___"